var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fade-in results-none d-flex flex-column text-center"},[_c('h2',{staticClass:"fs-3 fw-bold"},[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"fw-thin fs-5"},[_vm._v("\n        "+_vm._s(_vm.subMessage)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8a25f6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/EmptySearchResults.vue
// module id = 1652
// module chunks = 5